import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import { Box, Grid } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import CustomIcon from "components/customIcon";
import Currency from "components/Currency";
import classNames from "classnames";
import { get } from "lodash";
import StyledRates from "./styled";
import AccordionRoom from "./AccordionRoom";

const Rates = ({ rates, currentRate, handleSelectRate, t = (key) => key, dateRange = {} }) => {
  const [swiper, setSwiper] = useState(null);
  const navigationPrev = useRef(null);
  const navigationNext = useRef(null);

  useEffect(() => {
    swiper?.slideTo(currentRate.index);
  }, [currentRate.index, swiper]);

  useEffect(() => {
    if (swiper) {
      console.log(swiper);

      swiper.navigation.prevEl = navigationPrev.current;
      swiper.navigation.nextEl = navigationNext.current;
    }
  }, [swiper]);

  return (
    <StyledRates className="rate-swiper">
      <div className="rates-container">
        <div ref={navigationPrev} className="arrow arrow-prev">
          <CustomIcon color="white" icon="arrow-left-simple" />
        </div>
        <Swiper
          key={rates.length}
          onSwiper={setSwiper}
          breakpoints={{
            924: {
              slidesPerView: Math.min(rates.length, 4),
            },
            768: {
              slidesPerView: Math.min(rates.length, 3),
            },
            576: {
              slidesPerView: Math.min(rates.length, 2),
            },
            0: {
              slidesPerView: Math.min(rates.length, 1),
            },
          }}
          navigation={{
            prevEl: navigationPrev.current,
            nextEl: navigationNext.current,
            disabledClass: "disabled",
          }}
          modules={[Navigation]}
          className="mySwiper"
        >
          {rates.map((rate, index) => (
            <SwiperSlide key={rate.id} onClick={() => handleSelectRate(rate, index)} className={currentRate?.id === rate?.id ? "active" : ""}>
              <Box sx={{ paddingInline: { xs: "16px", lg: "24px" } }} className={classNames("rate-slide", { discount: rate.isDiscount })}>
                <h5 className="rate-name">
                  {get(rate, "name")}{" "}
                  {rate.isDiscount && (
                    <div className="rate-discount">
                      <span>
                        -{get(rate, "priceDiscount")}
                        {rate.priceType === "PERCENT" ? "%" : <Currency code={rate.currencyCode} />}
                      </span>
                    </div>
                  )}
                </h5>

                <p className="rate-price">
                  {!rate.isDiscount ? (
                    <>
                      {t("FROM")} <Currency code={rate.currencyCode} /> {get(rate, "minPrice", "-")}
                    </>
                  ) : (
                    <>
                      <span className="bold">
                        <Currency code={rate.currencyCode} />
                        {rate.minPrice}
                      </span>{" "}
                      / {rate.minimalStayDays} {t("NIGHTS")}
                    </>
                  )}
                </p>
              </Box>
            </SwiperSlide>
          ))}
        </Swiper>
        <div ref={navigationNext} className="arrow arrow-next">
          <CustomIcon color="white" icon="arrow-right-simple" />
        </div>
      </div>
      <div className="rooms-bottom">
        <Grid
          container
          justifyContent={"space-between"}
          direction={{
            xs: "column-reverse",
            sm: "column-reverse",
            md: "row",
          }}
        >
          <div className="accordion-box">
            <AccordionRoom activeRate={currentRate} />
          </div>
        </Grid>
      </div>
    </StyledRates>
  );
};

export default Rates;
